import { apiLink } from '../../constants/env';
import { getUnidade } from '../../funcs';
import axiosInstance, { AxiosAuth } from '../AxiosInstance';

const apiUnidade = {
    fetchApi: async (page, pageSize = 10) => {
        const URL = `/api/unidade/paged?page=${page}&pageSize=${pageSize}`;
        return await AxiosAuth.get(URL)
            .then((res) => res)
            .catch(error => {
                console.error('Erro ao buscar os dados:', error);
                throw new Error();

            })
    },

    getById: async (id) => {
        return new Promise((resolve, reject) => {
        try {
            const data = {data: getUnidade()};
            resolve(data);
        } catch (err) {
            reject(err);
        }
        });
    },

    findAsync: async() => {
        const URL = "/api/unidade";
        return await axiosInstance.get(URL)
            .then((res) => res)
            .catch(error => {
                throw error;
            })
    },

    getByUnidadeId: async (id) => {
        const URL = `/api/unidade/` + id;
        return await AxiosAuth.get(URL)
            .then((res) => res)
            .catch(error => {
                console.error('Erro ao buscar os dados:', error);
                throw new Error();

            })
    },

    postApi: async (unidade) => {
        const URL = `/api/unidade`;
        return await AxiosAuth.post(URL, unidade)
            .then((res) => res)
            .catch(error => {
                console.error('Erro ao buscar os dados:', error);
                throw new Error();
            })
    },
    postApiDetalhes: async (unidade) => {
    const URL = `/api/unidade`;
    return await axiosInstance.post(URL, unidade)
        .then((res) => res)
        .catch(error => {
            console.error('Erro ao buscar os dados:', error);
            throw new Error();
        })
    },
    deleteApi: async (id) => {
        const URL = `/api/unidade/status/${id}`;
        return await AxiosAuth.get(URL)
            .then((res) => res)
            .catch(error => {
                console.error('Erro ao buscar os dados:', error);
                throw new Error();

            })
    },
    putApi: async (id, unidade) => {
        const URL = `/api/unidade/${id}`;
        return await AxiosAuth.put(URL, unidade)
            .then((res) => res)
            .catch(error => {
                console.error('Erro ao buscar os dados:', error);
                throw new Error();

            })
    },
    getByEmpresaApi: async (id) => {
        const URL = `/api/unidade/empresa/${id}`;
        return await AxiosAuth.get(URL)
            .then((res) => res)
            .catch(error => {
                console.error('Erro ao buscar os dados:', error);
                throw new Error();

            })
    },
    selecionarUnidade: async (id) => {
        const URL = `/api/unidade/gerar-token-unidade/${id}`;
        return await AxiosAuth.get(URL)
            .then((res) => res)
            .catch(error => {
                console.error('Erro ao buscar os dados:', error);
                throw new Error();

            })
    }
}

export default apiUnidade;

